// extracted by mini-css-extract-plugin
module.exports = {"wrap":"SectionWithOverlappedImages_wrap__U7l94","images":"SectionWithOverlappedImages_images__AGpJt","inverted":"SectionWithOverlappedImages_inverted__3sF45"};